import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { team } from '../data/mock';

const Team = () => {
  return (
    <section id="equipe" className="py-20 bg-transparent">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Nossa <span className="text-[#D4AF37]">Equipe</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Profissionais especializados e apaixonados pelo que fazem, prontos para transformar seu visual.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {team.map((member, index) => (
            <Card 
              key={member.id}
              data-testid={`team-card-${member.id}`}
              className="bg-black/85 backdrop-blur-md border-zinc-800 hover:border-[#D4AF37] transition-all duration-300 group overflow-hidden"
              style={{
                animationDelay: `${index * 100}ms`
              }}
            >
              <div className="relative h-80 overflow-hidden">
                <img 
                  src={member.image} 
                  alt={member.name}
                  loading="lazy"
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                  style={(member.id === 1 || member.id === 4) ? { objectPosition: 'center center' } : {}}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <div className="h-1 w-16 bg-[#D4AF37] mb-3"></div>
                  <h3 className="text-white text-xl font-bold mb-1">{member.name}</h3>
                  <p className="text-[#D4AF37] text-sm font-medium">{member.specialty}</p>
                </div>
              </div>
              <CardContent className="pt-6">
                <p className="text-gray-400 text-sm">{member.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;